import React from "react";
import {
  FiArrowDownRight,
  FiArrowUpRight,
  FiClock,
  FiInfo,
} from "react-icons/fi";
import { DASHBOARD_MARKETS, DASHBOARD_RISK_NOTE } from "../../constants/dashboard.ts";

const getConfidenceColor = (successRate: number) => {
  if (successRate < 45) return "#ef4444";
  if (successRate < 65) return "#f59e0b";
  return "#2fbf78";
};

const getSignalMeta = (signalType?: string) => {
  const isCall = signalType === "CALL";
  return {
    label: isCall ? "CALL · Subida" : "PUT · Descida",
    icon: isCall ? FiArrowUpRight : FiArrowDownRight,
    pillClass: isCall
      ? "bg-[#dff8ec] text-[#087a45] ring-[#bcebd4]"
      : "bg-[#ffe5ec] text-[#e11d48] ring-[#ffd0dd]",
  };
};

const formatTime = (value?: string) => {
  if (!value) return "--:--";
  const match = value.match(/(\d{2}):(\d{2})/);
  return match ? `${match[1]}:${match[2]}` : value;
};

const getCategory = (pair?: string) => {
  if (!pair) return "Mercado";
  return DASHBOARD_MARKETS[pair] || "Mercado";
};

function SignalCard({ signal }) {
  const successRate = Number(signal?.successRate || 0);
  const confidenceColor = getConfidenceColor(successRate);
  const signalMeta = getSignalMeta(signal?.signalType);
  const SignalIcon = signalMeta.icon;

  return (
    <article className="group rounded-[18px] border border-[#dfe8e1] bg-white p-4 shadow-[0_14px_34px_rgba(20,44,33,0.075)] transition duration-200 hover:-translate-y-0.5 hover:border-[#bfe8d3] hover:shadow-[0_20px_48px_rgba(20,44,33,0.11)]">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          <h3 className="text-[19px] font-black tracking-[-0.02em] text-[#0d2a1f]">
            {signal?.pair || "---"}
          </h3>
          <p className="mt-0.5 text-xs font-semibold text-[#73827b]">
            {getCategory(signal?.pair)}
          </p>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-[#fff4df] px-2.5 py-1 text-xs font-bold text-[#f08700]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#ff9f0a]" />
          Ativo
        </span>
      </div>

      <div className="mb-3 flex items-center justify-between gap-3">
        <span
          className={`inline-flex items-center gap-2 rounded-xl px-3 py-1.5 text-sm font-black ring-1 ${signalMeta.pillClass}`}
        >
          <SignalIcon className="h-4 w-4" />
          {signalMeta.label}
        </span>

        <div className="text-right">
          <div className="flex items-center justify-end gap-1.5 text-sm font-black text-[#0d2a1f]">
            <FiClock className="h-4 w-4 text-[#789087]" />
            {formatTime(signal?.time)}
          </div>
          <p className="mt-0.5 text-xs font-semibold text-[#73827b]">
            M5 · 5 min
          </p>
        </div>
      </div>

      <div>
        <div className="mb-2 flex items-center justify-between">
          <span className="text-sm font-semibold text-[#73827b]">Confianca da IA</span>
          <span className="text-sm font-black text-[#078a50]">{successRate}%</span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-[#e7ece7]">
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{
              width: `${Math.min(successRate, 100)}%`,
              background: `linear-gradient(90deg, ${confidenceColor}, #8ee8b6)`,
            }}
          />
        </div>
        <p className="mt-1.5 flex items-center gap-1 text-[11px] font-semibold text-[#8b9b94]">
          <FiInfo className="h-3 w-3" />
          {DASHBOARD_RISK_NOTE}
        </p>
      </div>
    </article>
  );
}

export default SignalCard;
